<template>
  <div class='cve-trend-table-cell'>
    <v-icon :class='{ up: trendy, down: !trendy }'>
      {{ trendy ? 'trending_up': 'trending_down' }}
    </v-icon>
  </div>
</template>

<script>

export default {
  name: 'CveTrendTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    trendy() {
      return this.item[this.column.field] || false;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.cve-trend-table-cell {
  display: flex;
  align-items: center;
  font-family: $font-family-semibold;
  font-size: $font-size-base;
  font-weight: 600;
  letter-spacing: 0;
  line-height: rem(17);
  .up {
    color: var(--brand-primary);
  }
  .down {
    color: #FFA600;
  }
}
</style>
